var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/add old Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21-View-order-select-any-bullet-point",
    transform: "translate(-1064.000000, -799.000000)",
    fill: "#8CB1D5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket-information",
    transform: "translate(64.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/add-old-Copy-2",
    transform: "translate(1000.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C16.2989899,0 21,4.70101013 21,10.5 C21,16.2989899 16.2989899,21 10.5,21 C4.70101013,21 0,16.2989899 0,10.5 C0.00434300844,4.70281001 4.70281001,0.00434300844 10.5,0 Z M11.94375,4.055625 L9.05625,4.055625 L9.05625,9.05625 L4.055625,9.05625 L4.055625,11.94375 L9.05625,11.94375 L9.05625,16.944375 L11.94375,16.944375 L11.94375,11.94375 L16.944375,11.94375 L16.944375,9.05625 L11.94375,9.05625 L11.94375,4.055625 Z",
    id: "add"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisable);
export default __webpack_public_path__ + "static/media/add-disable.db155d109587b77cad528afb4bcafa49.svg";
export { ForwardRef as ReactComponent };